import { jsxs as m, jsx as t } from "react/jsx-runtime";
import { useEffect as l, useState as r } from "react";
import { Tabs as T, Theme as o, TabLayout as f, TabDesign as u } from "@nextgen-web-framework/all";
import { s as e, B as y } from "../../Brands-bfe7f409.mjs";
const { PURPLE: h } = o, { HORIZONTAL: x } = f, { TRANSPARENT: D } = u, A = (a) => {
  const n = a.brandData.tabsData.findIndex((s) => s.id === a.activeTabId);
  l(() => {
    n >= 0 ? d(n) : d(0);
  }, [a.activeTabId]);
  const [i, d] = r(n);
  return /* @__PURE__ */ m("div", { className: e["amway-brand-container"], "data-testid": "amway-brands-test-id", "data-pod-name": "commerce", children: [
    /* @__PURE__ */ t("h2", { className: e["amway-brand-title"], children: a.brandTitle }),
    /* @__PURE__ */ t("div", { className: e["amway-brand-tabs-scroller"], children: /* @__PURE__ */ t(
      T,
      {
        theme: h,
        layout: x,
        selectedTab: i,
        onTabClick: (s, b) => {
          var c;
          (c = a == null ? void 0 : a.callBack) == null || c.call(a, b), d(s);
        },
        design: D,
        tabList: a.brandData.tabsData
      }
    ) }),
    /* @__PURE__ */ t("div", { className: e["brand-item-wrapper"], children: /* @__PURE__ */ t(y, { tabData: a.brandData.tabsContent[i] }) })
  ] });
};
export {
  A as default
};
//# sourceMappingURL=AboutAmwayBrands.js.map
